import React from 'react';
import WingBlank from '../../components/WingBlank';
import './Footer.less';

const imageUrl = (title) => {
  return `/imgs/${title}.png`;
};

function Footer({company, about, abbr, address, phone, email}) {
  return (
    <WingBlank className='AppFooter'>
      <div data-role='logo'>
        <div><img src={imageUrl('footer_logo')} alt='logo cloudlink 云恋科技'/></div>
        <div>{company}</div>
      </div>
      <div data-role='contact'>
        <div>联系我们</div>
        <div>
          <div>{`联系电话：${phone}`}</div>
          <div>{`联系邮箱：${email}`}</div>
          <div>{`地址：${address}`}</div>
        </div>
      </div>
      <div data-role='care'>
        <div>微信公众号</div>
        <div>
          <img src={imageUrl('footer_2d_code')} alt='2d code'/>
          <div>
            <div>{`扫一扫关注${abbr}`}</div>
            <div>更多详情</div>
          </div>
        </div>
      </div>
    </WingBlank>
  );
}

export default Footer;


// WEBPACK FOOTER //
// ./src/routes/App/Footer.js